export default __webpack_public_path__ + "static/media/dialog_success.dda8feb7.svg";